import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteHandoverPlanRoutes = ({
  List,
  Create,
  Update,
  Copy
}: {
  List: React.ComponentType;
  Create: React.ComponentType;
  Update: React.ComponentType;
  Copy: React.ComponentType;
}) => (
  <Routes>
    <Route path="" element={<List />} />
    <Route path={ROUTES.WASTE_HANDOVER_PLAN.CREATE} element={<Create />} />
    <Route path={ROUTES.WASTE_HANDOVER_PLAN.EDIT} element={<Update />} />
    <Route path={ROUTES.WASTE_HANDOVER_PLAN.COPY.BASE} element={<Copy />} />
  </Routes>
);

